import Navbar from "./components/Navbar";
import FiltersGroup from "./components/FiltersGroup";
import ProductsList from "./components/ProductsList";
import { FiltersProvider } from "./context/FiltersContext";
import "./App.css";

const App = () => {
  return (
    <FiltersProvider>
      
      <div className="main-page">
        <Navbar />
        <div className="about-page">
          <h1>Discover Our Products</h1>
          <p>
            Browse our latest collection of premium goods designed for the modern
            lifestyle.
          </p>
        </div>
        <div className="filters-and-products">
        <FiltersGroup />
        <ProductsList />
      </div>
      </div>

      

      <footer>
        <p>&copy; 2024 Lumina Store. All rights reserved.</p>
        <div>
          <a href="/privacy">Privacy Policy</a>
          <a href="/terms">Terms of Service</a>
          <a href="/contact">Contact Us</a>
        </div>
      </footer>
    </FiltersProvider>
  );
};

export default App;
